const ConfrimCallDone = (): any => {
  return window.location.replace(
    "https://viralprofits.wistia.com/medias/wp3fjxktp7",
  );
};

export default ConfrimCallDone;
